var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointRedLargeBus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_600_5128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20.2682C6 10.7312 13.7312 3 23.2682 3H24.6683C34.2052 3 41.9365 10.7312 41.9365 20.2682C41.9365 29.8051 34.2052 37.5363 24.6683 37.5363H23.2682C13.7312 37.5363 6 29.8051 6 20.2682Z",
    fill: "#D08181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2682 4H24.6683V2H23.2682V4ZM24.6683 36.5363H23.2682V38.5363H24.6683V36.5363ZM23.2682 36.5363C14.2835 36.5363 7 29.2528 7 20.2682H5C5 30.3574 13.1789 38.5363 23.2682 38.5363V36.5363ZM40.9365 20.2682C40.9365 29.2528 33.653 36.5363 24.6683 36.5363V38.5363C34.7575 38.5363 42.9365 30.3574 42.9365 20.2682H40.9365ZM24.6683 4C33.653 4 40.9365 11.2835 40.9365 20.2682H42.9365C42.9365 10.1789 34.7575 2 24.6683 2V4ZM23.2682 2C13.1789 2 5 10.1789 5 20.2682H7C7 11.2835 14.2835 4 23.2682 4V2Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 16.875H32.125V19.375H30.875V16.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 16.875H17.125V19.375H15.875V16.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 22.5H27.75V23.75H26.5V22.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.5H21.5V23.75H20.25V22.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 12.5H20.875C20.0465 12.501 19.2522 12.8306 18.6664 13.4164C18.0806 14.0022 17.751 14.7965 17.75 15.625V24.375C17.7503 24.7064 17.8821 25.0242 18.1165 25.2585C18.3508 25.4929 18.6686 25.6247 19 25.625V27.5H20.25V25.625H27.75V27.5H29V25.625C29.3314 25.6245 29.649 25.4926 29.8833 25.2583C30.1176 25.024 30.2495 24.7064 30.25 24.375V15.625C30.249 14.7965 29.9194 14.0022 29.3336 13.4164C28.7478 12.8306 27.9535 12.501 27.125 12.5ZM29 16.25V20H19V16.25H29ZM20.875 13.75H27.125C27.5115 13.7511 27.8882 13.8719 28.2033 14.0957C28.5185 14.3195 28.7566 14.6354 28.885 15H19.115C19.2434 14.6354 19.4815 14.3195 19.7967 14.0957C20.1118 13.8719 20.4885 13.7511 20.875 13.75ZM19 24.375V21.25H29.0006L29.0013 24.375H19Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_600_5128",
    x: 0,
    y: 0,
    width: 47.9365,
    height: 46.5363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_600_5128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_600_5128",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointRedLargeBus);
export default __webpack_public_path__ + "static/media/point_red_large_bus.3df3e81eb1d8e9ecb2a417f049b4435a.svg";
export { ForwardRef as ReactComponent };